export const formatPrice = (price: number | bigint, decSpaces = 2) => {
    return new Intl.NumberFormat('bs-BA', {
        style: 'currency',
        currency: 'BAM',
        minimumFractionDigits: decSpaces,
        maximumFractionDigits: decSpaces,
    }).format(price ?? 0);
};